// import angular from 'angular';
import {RelivConferenceBadgePrintService} from './badge-print-service.js';

/**
 * relivConference.relivConferenceService
 */
angular.module('relivConference').service(
    'relivConferenceBadgePrintService',
    [
        '$window',
        'jQuery',
        function (
            $window,
            jQuery
        ) {
            return new RelivConferenceBadgePrintService(
                $window,
                jQuery
            );
        },
    ]
);
